module.exports = __webpack_public_path__ + "img/right-arrow2.4a9c734e.svg";